<script>
import _ from "lodash";

export default {
  name: "TheAdditionalInfoCardAch",
  
  props: {
    achievement: Object,
    revel: Boolean,
  },

  computed: {
    descriptionCard() {
      let description = this.achievement.description;
      const maxLength = 300;

      if (_.isNil(description) || description.length === 0) return "Описание не указано для данного достижения";
      if (description.length > maxLength) {
        description = description.substr(0, maxLength);
        description = description.substr(0, Math.min(description.length, description.lastIndexOf(" "))) + "...";
      }

      return description;
    },

    updatedDate() {
      const updatedAt = this.achievement.updated_at;
      if(_.isNil(updatedAt)) return "Отсутсвует";
      else return updatedAt;
    },

    achievementKindName() {
      const achievementKindName = this.achievement.prtf_achievement_kind_name;

      if(_.isNil(achievementKindName)) return "Отсутсвует";
      else return achievementKindName;
    },

  },

}
</script>

<template>
  <v-card
    class="transition-fast-in-fast-out v-card--reveal rounded-xl d-flex flex-column justify-start align-start"
    style="height: 100%;"
  >
    <v-card-title>
      <v-icon small @click="$emit('closeCard')">
        fa fa-times
      </v-icon>
    </v-card-title>
    <v-card-text class="pb-0">
      <p class="text-h5 text--primary">
        Описание
      </p>
      <p>{{descriptionCard}}</p>
    </v-card-text>
    <v-spacer/>
    <v-card-text>
      <p class="text-truncate">
        {{achievementKindName}}
      </p>
    </v-card-text>
    <v-card-text>
      <v-row>
        <v-col>
          Дата создания:
          <p class="black--text font-weight-bold">{{achievement.created_at}}</p>
        </v-col>
        <v-col>
          Дата обновления:
          <p class="black--text font-weight-bold">{{updatedDate}}</p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>